import React from "react";
import useMetaCampaigns from "../../../hooks/useMetaCampaigns";
import CampaignAccountHeader from "./CampaignAccountHeader";
import CampaignRotationRow from "./CampaignRotationRow";

/** One ad account's campaigns in rotation order, read-only, each tagged with its status on Meta. */
const CampaignsViewCard = ({ account }) => {
  const { statusById } = useMetaCampaigns({
    adAccountId: account.meta_ad_account_id,
  });
  const { campaigns } = account;

  return (
    <div className="rounded-xl border border-gray-200 bg-white">
      <CampaignAccountHeader account={account} count={campaigns.length} />
      <ol className="pt-1">
        {campaigns.map((c, index) => (
          <CampaignRotationRow
            key={c.meta_campaign_id}
            campaign={c}
            number={c.position ?? index + 1}
            status={statusById[c.meta_campaign_id]}
            isLast={index === campaigns.length - 1}
          />
        ))}
      </ol>
    </div>
  );
};

export default CampaignsViewCard;
